export default "__VITE_ASSET__DODegpYN__"